import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { useEffect, useState } from 'react';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import { cloneDeep } from 'lodash';
import gtm from '@/utils/gtm';
import { AnimatedGrid } from '@elem/compPage/delta-3-max-series/pages/product/us/StatusA/Components/AnimatedSection';

const ProductCard: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('ProductCard');

    const items = [
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758203947588-sksj9t-compressed-D3MP%E5%8F%B3%E4%BE%A7-%E6%97%A5%E8%A7%84%202.png',
            title: t('D3MS_product1_name'),
            desc: t('D3MS_product1_desc'),
            price: 0,
            compareAtPrice: 0,
            variantId: {
                us: '54718699962441',
                ca: '62106661618035',
            },
            shopNow: {
                us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718699962441',
                ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62106661618035',
            },
        },
        {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758203957481-nhnt1j-compressed-D3M%E6%8B%BC%E8%89%B2%E5%8F%B3%E4%BE%A7%E4%BF%AF-%E7%BE%8E%E6%97%A5%E8%A7%84%201.png',
            title: t('D3MS_product2_name'),
            desc: t('D3MS_product2_desc'),
            price: 0,
            compareAtPrice: 0,
            variantId: {
                us: '54692162764873',
                ca: '62060638372211',
            },
            shopNow: {
                us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54692162764873',
                ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62060638372211',
            },
        },
    ];

    const [dataItems, setDataItems] = useState(
        items.map((item) => {
            return {
                ...item,
                variantId: item.variantId[locale as 'us' | 'ca'],
                shopNow: item.shopNow[locale as 'us' | 'ca'],
            };
        }),
    );

    async function getItemInfo() {
        // const variantIds = tabs.map((tab) => tab.items.map((item) => item.variantId));
        const variantIds = dataItems.map((item) => item.variantId);

        const res = await getSolarRecommand2({ variantIds }, locale);
        if (res.code === '0') {
            // 找到对应的 item, 然后替换
            const newItems = cloneDeep(dataItems);

            res.data.forEach((item: any) => {
                const newItem = newItems.find((_item) => _item.variantId === item.variantId);
                if (newItem) {
                    newItem.pc = item.variantImg;
                    newItem.price = item.price;
                    newItem.compareAtPrice = item.compareAtPrice;
                    // newItem.title = item.skuTitle;
                }
            });

            setDataItems(newItems);
        }
    }
    useEffect(() => {
        getItemInfo();
    }, []);

    function onClick(shopNowLink: string, className: string) {
        window.open(shopNowLink, '_blank');

        gtm.push({
            __btn_id1: `${className}`,
            __btn_id2: className,
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    }

    return (
        <AnimatedGrid variant="rotateIn" options={{ delay: 100, stagger: 0.2 }} className={styles.ProductCard}>
            {dataItems.map((item, index) => (
                <div className="product-card" key={index}>
                    <div className="product-card-image">
                        <EcoImg pc={item.pc} isOpenLazy={true} />
                    </div>
                    <div className="product-card-content">
                        <div className="product-card-title">{item.title}</div>
                        <div className="product-card-desc">{item.desc}</div>
                        <div className="product-card-price">
                            <div className="product-card-price-current">{FormatMoneyLocal((item.price || 0).toFixed(2), locale)}</div>
                            <div className="product-card-price-compare">{FormatMoneyLocal((item.compareAtPrice || 0).toFixed(2), locale)}</div>
                        </div>
                        <div
                            className={'product-card-shop-now  GtmModuleData-btn-common ' + `d3m-product-card-shop-now-${index}`}
                            data-btn-id={`d3m-product-card-shop-now-${index}`}
                            onClick={() => onClick(item.shopNow, `d3m-product-card-shop-now-${index}`)}
                        >
                            {t('shopNow')}
                        </div>
                    </div>
                </div>
            ))}
        </AnimatedGrid>
    );
};

export default ProductCard;
